import React, { useContext } from 'react';
import { Text, TextTypography } from 'wix-ui-tpa/cssVars';
import settingsParams from '../../settingsParams';
import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { ISettingsContextValue } from '@wix/tpa-settings';
import { st, classes } from '../Widget.st.css';
import { st as headerStyle, classes as headerClasses } from './header.st.css';
import constants from '../../../../constants';
import { CategoriesPosition } from '../../../../enums';
import { DATA_HOOKS } from '../../../../constants/dataHooksElements';
import stylesParams from '../../stylesParams';
import { AppContext } from '../SettingsProvider/SettingsProvider';

const HeaderWrapper = () => {
  const { isEditor3 } = useContext(AppContext);
  const settings: ISettingsContextValue = useSettings();
  const styles = useStyles();
  const categoriesPosition: CategoriesPosition = settings.get(
    settingsParams.categoriesPosition,
  );
  const topCategoriesPosition =
    categoriesPosition === constants.DISPLAY_CATEGORIES.TOP;
  const { text, show, alignment } = settings.get(settingsParams.title);
  const titleText = isEditor3 ? settings.get?.(settingsParams.titleText) : text;
  const showTitleStyleParam = styles.get?.(stylesParams.showTitle) ?? true;
  const showTitle = show && showTitleStyleParam;
  const headerStyleParam = styles.get?.(stylesParams.headerTextFont);
  return (
    <>
      {showTitle && (
        <div
          className={st(classes.title, {
            isTopCategoriesPosition: topCategoriesPosition,
            alignment,
          })}
        >
          <Text
            tagName={headerStyleParam.htmlTag}
            className={headerStyle(headerClasses.title)}
            typography={TextTypography.largeTitle}
            data-hook={DATA_HOOKS.WIDGET_HEADER_TITLE_TEXT}
          >
            {titleText}
          </Text>
        </div>
      )}
    </>
  );
};

export default HeaderWrapper;
